import axios from "axios";
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { BASE_URL } from "../../../services/Api";
import { authHeader } from "../../../services/auth-header";
import Form from "react-bootstrap/Form";
import { Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import EditPumpDomesticSalesEnquiry from "./PumpDomesticSalesEnquiry/EditPumpDomesticSalesEnquiry";
import EditPumpInternationalSalesEnquiry from "./PumpInternationalSalesEnquiry/EditPumpInternatinalSalesEnquiry";
import EditAraiMfgSalesEnquiry from "./AraiMfgSalesEnquiry/EditAraiMfgSalesEnquiry";
import EditAraiMfgDomesticSE from "./AraiMfgDomesticSalesEnquiry/EditAraiMfgDomesticSE";

const EditSalesEnquiry = () => {
  const { id, pointindex } = useParams();
  const [productType, setProductType] = useState();
  const [productCategory, setProductCategory] = useState();
  const [enquiryData, setEnquiryData] = useState();

  async function getData() {
    try {
      const response = await axios.get(`${BASE_URL}enquiry/findById/${id}`, {
        headers: authHeader(),
      });

      setEnquiryData(response.data);
      setProductType(response.data.enquirytype);
      setProductCategory(response.data.enquirycategory);
    } catch (error) {
      console.log(error);
    }
  }

  function PageDisplay() {
    if (productType === "Pump Spare") {
      if (productCategory === "Domestic") {
        return <EditPumpDomesticSalesEnquiry enquiryData={enquiryData} />;
      } else if (productCategory === "International") {
        return <EditPumpInternationalSalesEnquiry enquiryData={enquiryData} />;
      }
    } else if (productType === "Manufacturing") {
      if (productCategory === "Domestic") {
        return <EditAraiMfgDomesticSE enquiryData={enquiryData} />;
      } else if (productCategory === "International") {
        return <EditAraiMfgSalesEnquiry enquiryData={enquiryData} />;
      }
    } else {
      return null;
    }
  }

  useEffect(() => {
    getData();
  }, []);

  console.log(enquiryData);

  return (
   
      <Card className="card">
        <Card.Header className="card-header">
          <h6>Edit Sales Enquiry</h6>
          <Link to={`/salesEnquiryIndex/${pointindex}`}>
            <button className="button-70">BACK</button>
          </Link>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md="6">
              <Form.Group>
                <Form.Label>Select Enquiry Type:</Form.Label>
                <Form.Select
                  onChange={(e) => {
                    setProductType(e.target.value);
                  }}
                  value={productType}
                  disabled={productType ? true : false}
                >
                  <option value="">--Please choose an option--</option>
                  <option value="Pump Spare">Pump Spare</option>
                  <option value="Manufacturing">Manufacturing</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md="6">
              <Form.Group>
                <Form.Label>Select a Enquiry Category:</Form.Label>
                <Form.Select
                  disabled={!productType ? true : false || productType === "arai-mfg" ? true : false || productCategory ? true : false}
                  value={productType === "arai-mfg" ? "International" : productCategory}
                  onChange={(e) => setProductCategory(e.target.value)}
                >
                  <option value="">--Please choose an option--</option>
                  <option value="Domestic">Domestic</option>
                  <option value="International">International</option>
                </Form.Select>
              </Form.Group>
            </Col>

            {PageDisplay()}
          </Row>
        </Card.Body>
      </Card>
  );
};
export default EditSalesEnquiry;
